import React, { Component } from 'react';
import axios from 'axios';
import { Card, Message, Loader, Icon } from 'semantic-ui-react';
import ReportHeader from 'dyzio-shared-components/lib/reports/report-header';
import InstagramStories from 'dyzio-shared-components/lib/components/instagram-stories';

class StoriesReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadingCampaign: true,
      isLoadingStories: false,
      loadingCampaignHasFailed: false,
      stories: [],
      campaign: null,
    };
    this.client = axios.create({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      timeout: 50000,
      headers: {
        Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBfbWV0YWRhdGEiOnsicm9sZXMiOlsiYWRtaW4iXSwiZHl6aW8iOnsidV9pZCI6ImM5Yjg4ZmJmLWU4YzctNDllNS05NjQxLWZhYjg1ZmQwYjg2MyIsIm5hbWUiOiJMYXVyaWUgQmFudGluIiwiZW1haWwiOiJsYXVyaWVAZHl6aW8uY28iLCJvX2lkIjoiNmMxYjY1M2UtZDcwNC00MDU1LWFjYzctNzlmMjgwZjUyM2Y2In19LCJpYXQiOjE1NDA4Mjg1NTAsImV4cCI6MTE1NDA4Mjg1NTAsImF1ZCI6Ik14dUVaa2FYcXVabmxKZUw5b0U4UWh5UXpoTXRqZlRwIiwiaXNzIjoiZHl6aW8uZXUuYXV0aDAuY29tIn0.bllt_b_L7KK1GEr8Spn5qVAqIP4wTjvuCmNDTShHfu4',
      },
    });
  }

  componentDidMount() {
    const { match: { params: { campaignId } } } = this.props;
    this.client.get(`/campaigns/${campaignId}`).then(response => {
      const { data: { data } } = response;
      this.setState({
        campaign: data.attributes,
        isLoadingCampaign: false,
        isLoadingStories: true,
        loadingCampaignHasFailed: false,
      }, () => {
        this.client.get(`/stories?filter[campaign]=${campaignId}`).then(res => {
          const { data: { data: stories } } = res;
          this.setState({
            stories,
            isLoadingStories: false,
          });
        });
      });
    });
  }

  render() {
    const {
      isLoadingCampaign,
      loadingCampaignHasFailed,
      campaign,
      isLoadingStories,
      stories,
    } = this.state;
    const headerInfo = {
      hasLogo: false,
      campaignName: campaign && campaign.name,
      reportDate: campaign && campaign.liveDate,
      reportType: 'Stories report',
    };
    return (
      <div>
        {
          isLoadingCampaign && <Loader active content="Please wait..." />
        }
        {
          !isLoadingCampaign && !loadingCampaignHasFailed &&
          <Card fluid>
            <Card.Content>
              <Message icon>
                <Icon name="file text outline" color="pink" />
                <Message.Content>
                  <Message.Header>{ campaign.name }</Message.Header>created by { campaign.createdBy }
                </Message.Content>
              </Message>
              <ReportHeader info={headerInfo} />
            </Card.Content>
          </Card>
        }
        <InstagramStories isLoading={isLoadingStories} stories={stories} />
      </div>
    );
  }
}

export default StoriesReport;



// WEBPACK FOOTER //
// ./src/containers/stories-report/index.js